/* src/app/report-list/report-list.component.scss */
div[role=toolbar] {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
div[role=toolbar] a {
  flex-basis: 3rem;
  text-align: left;
  color: unset;
  padding-left: 1rem;
  padding-top: 0.6rem;
  font-size: 1.1rem;
}
div[role=toolbar] a:hover {
  text-decoration: underline;
}
/*# sourceMappingURL=report-list.component.css.map */
